import { createLucideIcon } from 'lucide-react';
export const ToastErrorIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M16 8L8 16',
      key: 'wrjx8b',
    },
  ],
  [
    'path',
    {
      d: 'M18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604Z',
      key: '1yx76q',
    },
  ],
  [
    'path',
    {
      d: 'M8 8L16 16',
      key: 'dou0qj',
    },
  ],
]);
